import { render } from "./XiangshanMap.vue?vue&type=template&id=185687fa&scoped=true"
import script from "./XiangshanMap.vue?vue&type=script&lang=js"
export * from "./XiangshanMap.vue?vue&type=script&lang=js"

import "./XiangshanMap.vue?vue&type=style&index=0&id=185687fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185687fa"]])

export default __exports__